<template>
  <div class="home-box">
    <header>
      <div class="user">用户：{{ user }}</div>
      <button @click="signOut">退出</button>
    </header>
    <div
      class="main"
      ref="main"
      :style="{
        display: haveResult && queryResult.length > 0 ? 'flex' : 'none',
      }"
    >
      <div class="title">查询结果</div>
      <div class="search-result">
        <div
          class="search-result-item"
          v-for="(item, index) in queryResult"
          :key="index"
        >
          <div class="tr">
            <label>报告单号</label><label>{{ item.pat_id }}</label>
          </div>
          <div class="tr">
            <label>姓名</label><label>{{ item.pat_name }}</label>
          </div>
          <div class="tr">
            <label>性别</label><label>{{ item.pat_sex }}</label>
          </div>
          <div class="tr">
            <label>年龄</label><label>{{ item.pat_age }}</label>
          </div>
          <div class="tr">
            <label>审核医生</label><label>{{ item.pat_chk }}</label>
          </div>
          <div class="tr">
            <label>审核日期</label><label>{{ item.pat_date }}</label>
          </div>
          <div class="tr">
            <button
              @click="seeBaogaodan({ date: item.pat_date, id: item.pat_id })"
            >
              查&#8195;看
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isShowQuery"
      class="query-criteria"
      ref="query"
      @touchstart="drag"
    >
      查询条件
    </div>
    <transition @after-leave="afterLeave"
      ><Search
        v-if="isShowSearch"
        @hideSearch="hideSearch"
        :routeQuery="$route.query"
        :queryData="queryData"
        @querySuccess="querySuccess"
      ></Search
    ></transition>
    <div
      v-if="ReportFileUrl.length > 0"
      class="ReportFile-inner"
      @click="cancelSee"
    >
      <img class="baogaodan" :src="ReportFileUrl" alt="" />
    </div>
  </div>
</template>

<script>
import Search from "../components/search.vue";
import Vue from "vue";
export default {
  name: "Home",
  components: {
    Search,
  },
  data() {
    return {
      queryTop: 0,
      isShowSearch: false,
      isShowQuery: true,
      haveResult: false,
      user: "",
      queryData: null,
      queryResult: [],
      ReportFileUrl: "",
    };
  },
  mounted() {
    var that = this;
    this.queryTop = document.querySelector(".query-criteria").offsetTop;
    this.$refs.main.style.height =
      document.documentElement.clientHeight - 46 + "px";
    this.user = this.$route.query.username;
    setTimeout(() => {
      that.isShowSearch = true;
      that.isShowQuery = false;
      that.haveResult = false;
    }, 1000);
  },
  methods: {
    hideSearch() {
      this.isShowSearch = false;
      if (this.queryResult.length > 0) {
        this.haveResult = true;
      }
    },
    signOut() {
      this.$MessageBox.confirm("确定退出当前账户吗?").then(() => {
        this.$router.push("/");
      });
    },
    drag(e) {
      console.log("鼠标按下");
      console.log(e.target);
      var that = this;
      var queryDom = e.target; //浮动盒子
      this.queryTop = queryDom.offsetTop;
      var StartTime = new Date().getMilliseconds();
      var EndTime;
      var screenHeight = document.documentElement.clientHeight; //屏幕高度
      var pageY = e.touches[0].pageY; //鼠标位置
      var queryDomHeight = queryDom.offsetHeight; //浮动盒子高度
      var queryDomTop = queryDom.offsetTop; //盒子所在页面位置(竖向)
      var mouse_in_box_y = pageY - queryDomTop; //鼠标在盒子中的位置
      queryDom.ontouchmove = null;
      var jishiqi = setInterval(() => {
        EndTime = new Date().getMilliseconds();
        if (EndTime - StartTime > 200) {
          queryDom.ontouchmove = function (e) {
            console.log("鼠标移动");
            pageY = e.touches[0].pageY;
            var Top = pageY - mouse_in_box_y; //盒子最终的位置

            // 盒子上下移动最大区间
            var Min = 94;
            var Max = screenHeight - queryDomHeight;
            // console.log(Max)

            if (Top < Min) {
              Top = Min;
            }
            if (Top > Max) {
              Top = Max;
              // console.log(Top)
            }
            queryDom.style.top = Top + "px";
            that.queryTop = Top;
          };
          clearInterval(jishiqi);
        }
      }, 100);

      queryDom.ontouchend = function () {
        console.log("鼠标抬起");
        if (queryDom.ontouchmove != null) {
          queryDom.ontouchmove = null;
        } else {
          clearInterval(jishiqi);
          that.isShowQuery = false;
          that.isShowSearch = true;
          that.haveResult = false;
        }
      };
    },
    afterLeave() {
      this.isShowQuery = true;
      var queryTop = this.queryTop;
      Vue.nextTick(function () {
        document.querySelector(".query-criteria").style.top = queryTop + "px";
      });
    },
    querySuccess(value) {
      this.haveResult = true;
      this.isShowSearch = false;
      this.isShowQuery = true;
      this.queryData = value.Data;
      this.queryResult = value.Result;
      console.log(value.Data);
    },
    seeBaogaodan(value) {
      var that = this;
      this.$Loading.open("加载中");
      var params = {
        strPatid: value.id,
        strYear: value.date.substring(0, 4),
      };
      this.$axios
        .get("/api/MyLis/GetPatientReportFileUrl", { params: params })
        .then((res) => {
          that.$Loading.close();
          if (res.data != "-1") {
            that.ReportFileUrl = res.data.ReportFileUrl;
          } else {
            that.$Toast({
              message: "加载失败",
              duration: 1000,
            });
          }
        })
        .catch(() => {
          that.$Loading.close();
        });
    },
    cancelSee(e) {
      if (document.querySelector(".ReportFile-inner") == e.target) {
        this.ReportFileUrl = "";
      }
    },
  },
};
</script>
<style scoped>
.ReportFile-inner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #e7e7e7;
  background-color: rgba(0, 0, 0, 0.7);
}
.ReportFile-inner img {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 100vw;
  height: 50vh;
}
.home-box {
  width: 100vw;
  height: 100vh;
  background-image: url("../assets/background2.jpg");
  background-size: 100vw 100vh;
  padding-top: 46px;
  box-sizing: border-box;
}
header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  height: 40px;
  box-shadow: 0px 3px 5px 5px lightblue;
  display: flex;
  background-color: #d7eff9;
}
.user {
  font-size: 20px;
  box-sizing: border-box;
  padding-left: 15px;
  display: flex;
  align-items: center;
}
header button {
  margin-left: auto;
  border: 0;
  background-color: rgb(82, 182, 240);
  font-size: 14px;
  color: #fff;
  padding: 0 15px;
}
header button:active {
  background-color: rgb(11, 145, 223);
}
.main {
  width: 85%;
  margin: 0 auto;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 0.3rem;
}
.main .title {
  font-size: 28px;
  margin-bottom: 0.2rem;
}
.main .search-result {
  width: 100%;
  /* height: 470px; */
  height: 75vh;
  overflow: hidden;
  overflow-y: scroll;
}

.search-result::-webkit-scrollbar {
  width: 0 !important;
}
.search-result-item {
  border-radius: 10px;
}
.search-result-item .tr {
  box-sizing: border-box;
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;
}
.search-result-item .tr label:first-child {
  width: 20%;
  text-align: right;
}
.search-result-item .tr label:last-child {
  width: 70%;
  text-align: left;
}
.search-result-item .tr button {
  margin-left: auto;
  padding: 5px 10px;
  /* border: 1px solid rgb(93, 186, 223); */
  border-radius: 4px;
  border: 0;
  background-color: rgb(93, 186, 223);
  color: #fff;
}
.search-result-item .tr button:active {
  background-color: rgb(51, 167, 212);
}
.search-result-item:nth-child(odd) {
  background-color: rgb(231, 238, 235);
}
.search-result-item:nth-child(even) {
  background-color: rgb(214, 218, 218);
}
.query-criteria {
  position: fixed;
  border: 3px solid rgb(245, 218, 100);
  border-right: 0;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  font-size: 14px;
  letter-spacing: 6px;
  writing-mode: vertical-rl;
  padding: 5px 1px;
  background-color: #fff;
  font-weight: 700;
  color: rgb(71, 162, 248);
  user-select: none;
}
.v-enter {
  left: 100%;
}
.v-enter-to {
  left: 0;
}
.v-enter-active {
  transition: all 2s;
}
.v-leave {
  left: 0;
}
.v-leave-active {
  transition: all 0.8s;
}
.v-leave-to {
  left: 100%;
}
</style>  